import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router";
import authService from "../../Services/authService";
import clinicService from "../../Services/clinicService";
import utils from "../../Utils";
import strings from "../../Utils/strings";
import OffCanvas from "../common/offCanvas";
import AddDoctor from "../manageClinic/addDoctor";
import AddDocNew from "../manageClinic/AddDocNew";
import ViewSpecialityList from "./ViewSpeciality/viewSpecialityList";
import { t } from "../../Utils/translate";
import "./manageDoctor.css";
import Widgets from "../../Widgets";

function ManageDoctor() {
  const isFetched = useRef(false);
  const nav = useNavigate();
  const [doctorDetails, setDoctorDetails] = useState([]);
  const [offCanvasOpen, setOffCanvasOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [doctorUsername, setDoctorUsername] = useState("");
  const [userNameErr, setUserNameErr] = useState("");
  const [viewSpecialty, setViewSpecialty] = useState(false);
  const [doctorEmailId, setDoctorEmailId] = useState("");
  const [doctorEmailIdErr, setDoctorEmailIdErr] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [doctorOptions, setDoctorOptions] = useState([]);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  useEffect(() => {
    if (!isFetched.current) {
      getClinicProfile();
      isFetched.current = true;
    }
    setUserNameErr("");
  }, []);

  const getClinicProfile = async () => {
    try {
      setIsLoading(true);
      // setIsLoading(true);
      const response = await clinicService.getDoctorList();
      // setIsLoading(false);
      if (response && response.status) {
        const doctors = response.data.doctors;
        const options = doctors.map((doctor) => ({
          value: doctor._id,
          label: doctor.name,
        }));
        setDoctorOptions(options);
        setDoctorDetails(response.data.doctors);
      }
    } catch (error) {
      // setIsLoading(false);
      // console.error("Error fetching doctor list:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   if (doctorDetails.length === 0) { // Run only if doctorDetails is empty
  //     getClinicProfile();
  //   }
  //   setUserNameErr("");
  // }, [doctorDetails]);

  const handleClose = () => {
    setOffCanvasOpen(false);
    getClinicProfile();
  };

  const disableButton = () => {
    let returnValue = false;
    if (utils.utilFunctions.emptyCheck(doctorUsername) && userNameErr === "" && utils.utilFunctions.emptyCheck(doctorEmailId) && doctorEmailIdErr === "") {
      returnValue = false;
    } else {
      returnValue = true;
    }

    return returnValue;
  };

  const handleViewSpecialtyClose = () => {
    setViewSpecialty(false);
    setTimeout(() => {
      getClinicProfile();
    }, 100); // Adjust delay time as needed
  };

  console.log("doctor details", doctorDetails);

  return (
    <>
      {isLoading ? (
        <Widgets.CircularLoader />
      ) : (
        <div>
          <div
            style={{
              overflow: "auto",
            }}
            className=" px-3"
          >
            <div className="d-flex justify-content-between">
              <div className="screen-name flex-grow-1 mt-2">{t("labelManageDoctor")}</div>
              <div className="dropdown more-details-clinic-profile" onClick={toggleDropdown}>
                <button className="dropbtn manage-dropbtn">
                  <i className="ri-more-2-line"></i>
                </button>
                <div className="dropdown-content more-details-clinic-profile">
                  <a
                    onClick={() => {
                      setViewSpecialty(true);
                    }}
                  >
                    {t("viewSpeciality")}
                  </a>
                  <a
                    onClick={() => {
                      setOffCanvasOpen(true);
                    }}
                  >
                    {t("labelAddDoctor")}
                  </a>
                </div>
              </div>
              <div
                className="manage-leave me-2"
                onClick={() => {
                  setViewSpecialty(true);
                }}
              >
                <button type="button" className="btn btn-danger leave mt-2 text-nowrap d-flex speciality-btn">
                  {t("viewDeparment")}
                </button>
              </div>
              <div
                className="manage-leave"
                onClick={() => {
                  setOffCanvasOpen(true);
                }}
              >
                <button type="button" className="btn btn-danger mt-2 text-nowrap add-doctor-btn">
                  {t("labelAddDoctor")}
                </button>
              </div>
            </div>
            <OffCanvas show={offCanvasOpen} onHide={handleClose} title={t("labelAddDoctor")}>
              <AddDocNew onClose={handleClose} />
            </OffCanvas>
            <OffCanvas
              show={viewSpecialty}
              onHide={handleViewSpecialtyClose}
              title={t("labelDeparment")}
              className="speciality-offcanvas"
              specialityBodyClassName="speciality-offcanvas-body"
              iconClassName="d-flex justify-content-center offcanvas-arrow position-absolute speciality-icon"
            >
              <ViewSpecialityList onClose={handleViewSpecialtyClose} />
            </OffCanvas>
            <div className="table-wrapper">
              <table className=" table manage-doctor-table">
                <thead className="manage-doctor-heading">
                  <tr>
                    <th className="manage-table-doctor-profile-pic"></th>
                    <th className="manage-table-doctorname text-nowrap ">{t("labelDoctorName")}</th>
                    <th className="manage-table-doctorid text-nowrap">{t("labelDoctorId")}</th>
                    <th className="manage-table-qualification">{t("labelQualification")}</th>
                    <th className="manage-table-speciality">{t("labelSpecialization")}</th>
                    <th className="manage-table-mobile-number">{t("labelMobile")}</th>
                    <th className="manage-table-doctor-profile text-nowrap "> {t("doctorProfile")}</th>
                  </tr>
                </thead>
                <tbody className="manage-table-body">
                  {doctorDetails.map((data, i) => {
                    return (
                      <tr className="manage-table-row">
                        <td>
                          {" "}
                          {data.profilePic === "null" || data.profilePic === null ? (
                            <div style={{ marginTop: "10px" }} className="doctorProfilePic">
                              <i className="ri-nurse-line profile-clinic-img manage"></i>
                            </div>
                          ) : (
                            <div style={{ marginTop: "5px" }} className="doctorProfilePic">
                              <img src={data.profilePic} className="profile-clinic-img" alt="image" />
                            </div>
                          )}
                        </td>
                        <td className="text-max-length ">
                          <div style={{ paddingTop: "2px" }} className="custom-display-flex">
                            {data.name}
                          </div>
                        </td>
                        <td className="text-max-length ">
                          <div style={{ paddingTop: "2px" }} className="custom-display-flex">
                            {data.employeeID}
                          </div>
                        </td>
                        <td className="text-max-length ">
                          <div style={{ marginTop: "12px", paddingTop: "2px" }} className="custom-display-flex">
                            {data.qualification}
                          </div>
                        </td>
                        <td>
                          <div style={{ marginTop: "18px" }} className="  ">
                            {data.department && data.departmentList.length < 0 ? (
                              data.department.departmentName
                            ) : (
                              <span className="depart">
                                {data.departmentList.slice(0, 3).map((depart, i) => {
                                  let departName = [];
                                  if (i === 2 && data.departmentList.length > 3) {
                                    departName.push("etc..,");
                                  } else {
                                    departName.push(depart.departmentName);
                                    if (i !== data.departmentList.length - 1) {
                                      departName.push(",");
                                    }
                                    departName.push(" ");
                                  }
                                  return <span>{departName}</span>;
                                })}
                              </span>
                            )}
                          </div>
                        </td>
                        <td>
                          <div style={{ marginTop: "12px", paddingTop: "2px" }} className="custom-display-flex">
                            {data.countryCode.includes("+") ? data.countryCode : strings.viewProfile.plus_icon + data.countryCode} {data.phoneNumber}
                          </div>
                        </td>
                        <td>
                          <button
                            type="button"
                            style={{ marginTop: "14px" }}
                            className="btn btn-sm btn-md btn-danger view-profile-button text-nowrap "
                            onClick={() => {
                              nav(utils.strings.navigation.doctorProfileView, {
                                state: {
                                  doctorId: data._id,
                                },
                              });
                              authService.setDoctorID(data._id);
                            }}
                          >
                            {t("viewProfile")}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ManageDoctor;
